import { render } from "./card.vue?vue&type=template&id=4c46986c&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=4c46986c&lang=scss"
import "./card.vue?vue&type=style&index=1&id=4c46986c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c46986c"]])

export default __exports__